var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgSyringePlus = function SvgSyringePlus(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    role: "img",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m12.304 7.087 6.609 6.609m-1.391-1.392-5.392 5.392a2.705 2.705 0 0 1-3.826 0m5.392-9.218L8.304 13.87M20.13 7.957l-3.478 3.478m-2.087-2.087 3.479-3.478m-.87-.87L21 8.826M5 21l3.304-3.304m0 0a2.705 2.705 0 0 1 0-3.826m0 0 1.218 1.217m.185-2.598 1.206 1.207m.174-2.609 1.217 1.217"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 6h6M6 3v6"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSyringePlus);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;